//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        background: {
            type: String,
            default: ''
        },
        bubbleText: {
            type: String,
            default: function () {
                return this.$lang.get('partials.daily.party', {br: '\n'});
            }
        },
        route: {
            type: String,
            default: 'next'
        }
    },

    computed: {
        stars () {
            return this.$store.getters.stars;
        },
        learned () {
            let achievement = this.$store.getters.achievements.find(achievement => achievement.week === this.$route.meta.week && achievement.day === this.$route.meta.day);

            return achievement && achievement.learned && achievement.learned[this.$lang.locale] ? achievement.learned[this.$lang.locale] : [];
        }
    },

    created () {
        if (this.$store.getters.hasUserFinishedWeek(this.$route.meta.week)) {
            this.$router.push({ name: 'next' });
        }
    }
};
